<template>
  <v-card
    class="mx-auto my-12"
    max-width="374"
  >

    <v-card-title>坪坪乌鸡蛋</v-card-title>

      <v-carousel 
        :continuous="false"
      :show-arrows="false"
      height="360">
    <v-carousel-item :key="i" v-for="(banner, i) in banners" >
          <v-sheet tile >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
            <v-img height=250 :src="banner"> </v-img>
        </v-row>
          </v-sheet>

      <v-list one-line>
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="icons[i]"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title><v-text-field :label="titles[i]"> </v-text-field>  </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    </v-carousel-item>
  </v-carousel>


    <v-card-text>
       <v-alert color="green">安全、营养、健康、美味</v-alert>
       <v-alert color="green">¥86/盒  </v-alert>
       <v-alert color="green">联系人:奥利云 电话: 13934364838 </v-alert>
    </v-card-text>


      <v-list one-line>
      <v-list-item>
        <v-list-item-avatar>
      <v-img height="32" width="32" src="/favicon.ico" ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title> 兴县利云种养有限公司 </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
 

  </v-card>
</template>


<script>
  export default {
         data: () => ({
        banners: [ '/4.jpg', '/3.jpg', '/2.jpg', '/1.jpg' ],
        icons: [ '/wu.jpg', '/wu.jpg', '/green1.jpg', '/green1.jpg' ],
        titles: [ '无公害农产品(鸡蛋): WGH-SX02-1800169', '大豆绿色认证: LB-07-19080407134A','滩枣绿色认证: LB-19-19070406391A'],
    })
  }
</script>
